module.exports = __webpack_public_path__ + "static/media/icon_transform.5b1cea1e.svg";